"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var LftInputBase = react_1.default.forwardRef(function (_a, ref) {
    var _b, _c;
    var ariaDescribed = _a.ariaDescribed, accept = _a.accept, autoComplete = _a.autoComplete, autoFocus = _a.autoFocus, checked = _a.checked, dataElement = _a.dataElement, dataInfo = _a.dataInfo, dataLift = _a.dataLift, dataTestId = _a.dataTestId, defaultChecked = _a.defaultChecked, disabled = _a.disabled, id = _a.id, min = _a.min, max = _a.max, maxLength = _a.maxLength, multiple = _a.multiple, name = _a.name, placeholder = _a.placeholder, required = _a.required, tabIndex = _a.tabIndex, type = _a.type, role = _a.role, step = _a.step, rows = _a.rows, value = _a.value, lftBlur = _a.lftBlur, lftChange = _a.lftChange, lftClick = _a.lftClick, lftFocus = _a.lftFocus, lftMouseDown = _a.lftMouseDown, lftMouseUp = _a.lftMouseUp, lftKeyDown = _a.lftKeyDown, lftKeyUp = _a.lftKeyUp;
    var handleBlur = function (e) {
        !!lftBlur && lftBlur(e);
    };
    var handleChange = function (e) {
        !!lftChange && lftChange(e);
    };
    var handleClick = function (e) {
        !!lftClick && lftClick(e);
    };
    var handleFocus = function (e) {
        !!lftFocus && lftFocus(e);
    };
    var handleMouseDown = function (e) {
        !!lftMouseDown && lftMouseDown(e);
    };
    var handleMouseUp = function (e) {
        !!lftMouseUp && lftMouseUp(e);
    };
    var handleKeyDown = function (e) {
        !!lftKeyDown && lftKeyDown(e);
    };
    var handleKeyUp = function (e) {
        !!lftKeyUp && lftKeyUp(e);
    };
    if (dataElement) {
        if (!dataElement.startsWith("input_") && dataElement.includes('_')) {
            if (typeof window !== 'undefined' &&
                (((_b = window.location.href) === null || _b === void 0 ? void 0 : _b.indexOf('localhost')) > -1 || ((_c = window.location.href) === null || _c === void 0 ? void 0 : _c.indexOf('dev')) > -1)) {
                console.warn('Não é necessário mais informar o prefixo no atributo dataElement');
            }
        }
        else {
            if (type === 'radio') {
                dataElement = "radio_" + dataElement;
            }
            else {
                dataElement = "input_" + dataElement;
            }
        }
    }
    if (type !== 'textarea') {
        return ((0, jsx_runtime_1.jsx)("input", { "aria-describedby": ariaDescribed, accept: accept, "aria-checked": checked, "aria-placeholder": placeholder, "aria-required": required, autoComplete: autoComplete, autoFocus: autoFocus, checked: checked, "data-element": dataElement, "data-info": dataInfo, "data-lift": "lft-input-" + dataLift, "data-testid": dataTestId ? dataTestId : id && id, defaultChecked: defaultChecked, disabled: disabled, id: id, min: min, max: max, maxLength: maxLength, multiple: multiple, name: name, placeholder: placeholder, ref: ref, required: required, tabIndex: disabled ? -1 : tabIndex, type: type, role: role, value: value, step: step, onBlur: handleBlur, onChange: handleChange, onClick: handleClick, onFocus: handleFocus, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp }, void 0));
    }
    else {
        return ((0, jsx_runtime_1.jsx)("textarea", { "aria-describedby": ariaDescribed, "aria-placeholder": placeholder, "aria-required": required, autoFocus: autoFocus, "data-element": dataElement, "data-info": dataInfo, "data-lift": "lft-input-" + dataLift, "data-testid": dataTestId ? dataTestId : id && id, disabled: disabled, id: id, maxLength: maxLength, name: name, placeholder: placeholder, ref: ref, required: required, tabIndex: disabled ? -1 : tabIndex, value: value, role: role, rows: rows, onBlur: handleBlur, onChange: handleChange, onClick: handleClick, onFocus: handleFocus, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp }, void 0));
    }
});
exports.default = LftInputBase;
